import { useState, useEffect } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
} from "@react-google-maps/api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { ApiConfig } from "@shared/Config/config";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "8px",
};

export default function LocationPickerModal({ open, onClose, onSelect }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: ApiConfig.googleMapKey, // 🔑 replace with your API key
  });

  const [center, setCenter] = useState(null);
  const [selected, setSelected] = useState(null);

  // Get user's current location
  useEffect(() => {
    if (open && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting location:", error);
          setCenter({ lat: 20.5937, lng: 78.9629 }); // default: India center
        }
      );
    }
  }, [open]);

  const handleMapClick = (e) => {
    const coords = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setSelected(coords);
  };

  const handleConfirm = () => {
    if (selected) {
      onSelect(selected);
      onClose();
    }
  };

  if (loadError) return <div>Error loading maps</div>;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select Location</DialogTitle>
      <DialogContent>
        {!isLoaded || !center ? (
          <div
            style={{
              height: "400px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={14}
            onClick={handleMapClick}
          >
            {selected && <Marker position={selected} />}
          </GoogleMap>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          disabled={!selected}
          variant="contained"
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
